/** Keycloak の OIDC 設定(Authorization Code + PKCE)。 */
import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

import type { RuntimeConfig } from "./config";

const RETURN_TO = "itmgmt.returnTo";

/** ログイン後に戻る先を覚えておく(直リンクで来た人をそのページへ返す)。 */
export function rememberReturnTo(path: string) {
  try {
    sessionStorage.setItem(RETURN_TO, path);
  } catch {
    /* プライベートブラウズ等で書けなくても致命的ではない */
  }
}

/** 覚えておいた戻り先を1回だけ取り出す。 */
export function consumeReturnTo(): string | null {
  try {
    const v = sessionStorage.getItem(RETURN_TO);
    sessionStorage.removeItem(RETURN_TO);
    return v || null;
  } catch {
    return null;
  }
}

export function oidcConfig(config: RuntimeConfig): AuthProviderProps {
  return {
    authority: `${config.keycloakUrl}/realms/${config.realm}`,
    client_id: config.clientId,
    redirect_uri: `${window.location.origin}/`,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: "code", // PKCE(S256)は oidc-client-ts が自動で付ける
    scope: "openid profile email",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    // URL に残る code / state の掃除と戻り先への復帰は AuthGate がやる
    // (history.replaceState だけでは react-router が気づかないため)
  };
}


export function discardHelpSession() {
  window.dispatchEvent(new Event("itmgmt-signout"));
}

export async function signOut(auth: { signoutRedirect: () => Promise<void> }) {
  discardHelpSession();
  if (typeof BroadcastChannel !== "undefined") {
    const channel = new BroadcastChannel("itmgmt-auth");
    channel.postMessage("signout");
    channel.close();
  }
  await auth.signoutRedirect();
}
